import { type FC } from 'react';
import { createPortal } from 'react-dom';

import { FiltersOverlay } from '@/app/shared/components/FiltersOverlay';
import { useElementsRefContext } from '@/app/shared/context/ElementsRefContext';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useBrowserPageIsPageReloadingSelector } from '@/packages/redux-state/store/slices/browserPage';
import { getIsBrowserBuild } from '@/packages/utils/isBuildType';

export const FiltersOverlayCenter: FC = () => {
  const { filtersRef } = useElementsRefContext();
  const { isRefetching } = useSearchOffersDesktopQuery();
  const isPageReloading = useBrowserPageIsPageReloadingSelector();

  const showSpinner = (isRefetching || isPageReloading) && getIsBrowserBuild();

  if (filtersRef.current) {
    return createPortal(<FiltersOverlay isDataLoading={showSpinner} />, filtersRef.current);
  }

  return null;
};
